import { render } from "./SelecionarTipoConta.vue?vue&type=template&id=f62c5e6c&scoped=true&ts=true"
import script from "./SelecionarTipoConta.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoConta.vue?vue&type=script&lang=ts"

import "./SelecionarTipoConta.vue?vue&type=style&index=0&id=f62c5e6c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f62c5e6c"]])

export default __exports__